import Loadable from '../../components/loadable';

const ViewInterruptionRequest = Loadable({
  loader: () =>
    import(
      '../../pages/contacts/membership_interruptions/membership_interruption_request/view_interruption_request'
    ),
  type: 'block',
});

angular.module('gym').value('ViewInterruptionRequest', ViewInterruptionRequest);
